<template>
  <v-text-field
    v-on="computedListeners"
    v-bind="computedProps"
    label=""
    solo
    flat
    class="border-none"
    :placeholder="phtext"
    :tabindex="readonly ? -1 : 0"
    @dblclick="setCurrentMonth()">
      <template v-slot:append>
        <v-menu v-if="!readonly" v-model="isShowCalendar" :close-on-content-click="false" origin="top left">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="primary"
              elevation="0"
              tabindex=-1
              icon
              dark
              small
              @click="onIconClick">
              <svg data-name="Icon - Calender" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path d="M15.8,4A2.913,2.913,0,0,0,13,2V0H11V2H5V0H3V2A2.913,2.913,0,0,0,.2,4Z" fill="#83bde5"/>
                <path d="M0,5v8a2.946,2.946,0,0,0,3,3H13a2.946,2.946,0,0,0,3-3V5Zm5,8H3V11H5ZM5,9H3V7H5Zm4,4H7V11H9ZM9,9H7V7H9Zm4,0H11V7h2Z" fill="#83bde5"/>
              </svg>
            </v-btn>
          </template>
          <v-date-picker
            elevation="8"
            locale="jp-ja"
            v-model="calendarDate"
            no-title
            type="month"
            :max="calendarMax"
            :min="calendarMin"
            @input="onCalendarInput">
            <v-spacer></v-spacer>
            <dd-custom-button dark dense @click="isShowCalendar = false">閉じる</dd-custom-button>
            <v-spacer></v-spacer>
            <dd-custom-button dark dense @click="setCurrentMonth(1)">当月</dd-custom-button>
            <v-spacer></v-spacer>
          </v-date-picker>
        </v-menu>
      </template>
  </v-text-field>
</template>
<script>
import { VTextField } from 'vuetify/lib'
import inputMixin from '@/mixins/inputMixins'
import controls from '@/rahmen/controls'
import complements from '@/rahmen/complement'
import validators from '@/rahmen/validators'

import date from '@/ddv2.library/date'

import DdCustomButton from '@/components/DdCustomButton'

/**
 * @file DDv2用年月入力
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須有無
 * @vue-prop {String} [max='']- 許容最大値(デフォルト:2999/12/31)
 * @vue-prop {String} [min=''] - 許容最小値(デフォルト:2000/01/01)
 * @vue-prop {String} [errorMessages=''] - エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-text-field/
 * @example
  <dd-date-box
    label="適用開始日"
    v-model="dateValue"
    max="2099/12/31"
    min="2000/01/01"/>
 */
export default {
  name: 'DdMonthBoxInside',
  extends: VTextField,
  components: {
    DdCustomButton
  },
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能最大値
     */
    max: String,
    /**
     * 入力可能最小値
     */
    min: String,
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String
  },
  data: () => ({
    hasFocus: false,
    invalidMessage: '',
    innerValue: '',
    isShowCalendar: false,
    calendarDate: '',
    defaultMax: '2999/12',
    defaultMin: '2000/01'
  }),
  created () {
  },
  mounted () {
    this.invalidMessage = this.errorMessages
    this.innerValue = this.value
  },
  watch: {
    value: function (n, o) {
      this.innerValue = n
    }
  },
  computed: {
    inputTypeDetail () {
      return controls.getInputTypeDetail(controls.InputTypes.YearMonth)
    },
    phtext () {
      if (!this.inputTypeDetail) {
        return ''
      } else {
        return !this.readonly ? this.inputTypeDetail.placeholder.replace('@@length@@', this.length) : ''
      }
    },
    calendarMax () {
      if (this.max) {
        return this.max.split('/').join('-')
      }
      return undefined
    },
    calendarMin () {
      if (this.min) {
        return this.min.split('/').join('-')
      }
      return undefined
    },
    computedProps () {
      return {
        ...this.$props,
        value: this.innerValue,
        maxlength: this.length,
        class: this.required && !this.readonly ? ' required-item' : this.class,
        hideDetails: 'auto',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this.complement()
      if (!this.isShowCalendar) {
        this[controls.VALIDATE_METHOD]()
      }
      if (!this.hasError) {
        // this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
      const val = this.lazyValue
      if (this.lazyValue !== null && this.lazyValue !== '' && this.lazyValue !== undefined) {
        this.innerValue = val.split('/').join('')
      }
      const elem = this.$el.querySelector('input')
      console.log('DdDateBox.onFocus', elem)
      this.$nextTick().then(() => {
        if (elem) { elem.select() }

        /**
         * フォーカス設定
         * @event focus
         * @type {Event}
         */
        this.$emit('focus', e)
      })
    },
    complement: function () {
      const val = complements.parseYearMonth(this.lazyValue)
      this.$set(this, 'innerValue', val)
      this.$emit('input', val)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        max: this.max === undefined ? this.defaultMax : this.max,
        min: this.min === undefined ? this.defaultMin : this.min
      }
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(controls.InputTypes.YearMonth)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    },
    onIconClick: function (e) {
      console.log('DdMonthRangeBox.onIconClick', e, this.lazyValue)
    },
    onCalendarInput: function (e) {
      console.log(e)
      this.innerValue = e.split('-').join('/')
      /**
       * カレンダー選択値input
       * @event input
       * @type {Event}
       */
      this.$emit('input', this.innerValue)
      this.isShowCalendar = false
      this[controls.VALIDATE_METHOD]()
    },
    setCurrentMonth: function () {
      if (this.readonly) return

      console.log('setCurrentMonth')
      if ([undefined, null, ''].includes(this.innerValue)) {
        this.innerValue = date.getCurrentMonth()
        this.$emit('input', this.innerValue)
        this[controls.VALIDATE_METHOD]()
      }
      this.isShowCalendar = false
    }
  }
}
</script>
<style scoped>
.v-picker.v-card.v-picker--date {
  position: absolute;
  z-index: 500;
}
.mdi-calendar::before {
  color: #2196F3;
}
.v-menu__content.theme--light {
  width: 290px !important;
  height: 336px !important;
}
</style>
